import React from 'react'
import RenderProfile from '../../../../_components/Profile'
import { Card, Col, Row } from 'react-bootstrap'

export default function UserDetailsCard({ user, children }) {

  const renderStatus = (status) => {
    switch(status) {
      case 'Active':
        return <span style={{opacity: '0.7', width: '60px'}} className="badge badge-success py-2">Active</span>
      case 'Pending':
        return <span style={{opacity: '0.7', width: '60px'}} className="badge badge-warning text-light py-2">Pending</span>
      case 'Inactive':
        return <span style={{opacity: '0.7', width: '60px'}} className="badge badge-danger py-2">Inactive</span>
      default: 
        return null
    }
  }

  let fullName = `${user.firstName} ${user.lastName}`

  if (user.credentials) {
    fullName = `${fullName}, ${user.credentials}`
  }

  return (
    <Card className='border-0 axs-shadow axs-rounded'>
      <Card.Body>
        <Row>
          <Col>
            <RenderProfile 
              name={fullName}
              type={user.specialtyTitle}
              cached={false}
              profileUrl={user.profileUrl}
            />
          </Col>
        </Row>

        <Row className='mt-3'>
          <Col className='text-center'>
            {renderStatus(user.status)}
            { user.status === 'Pending' &&
              <h6 className="text-muted mt-3">An account setup email has been sent.</h6>
            }
          </Col>
        </Row>
        <br />
        <Row>
          <Col className='lead'>
              <b>Details</b>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col>
            Username:
          </Col>
        </Row>
        <Row>
          <Col className='text-muted font-weight-light'>
            { user.username }
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            Email:
          </Col>
        </Row>
        <Row>
          <Col className='text-muted font-weight-light'>
            { user.email }
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            Role:
          </Col>
        </Row>
        <Row>
          <Col className='text-muted font-weight-light'>
            { user.role }
          </Col>
        </Row>
        { children }
      </Card.Body>
    </Card>
  )
}
